(function () {
  'use strict';

  var input    = document.querySelector('[data-ks-search-input]');
  var dropdown = document.querySelector('[data-ks-search-dropdown]');
  var clearBtn = document.querySelector('[data-ks-search-clear]');
  if (!input || !dropdown) return;

  var timer       = null;
  var activeIndex = -1;

  /* ── Helpers ──────────────────────────────────────────────────── */
  function money(amount) {
    return window.KitstersMoney.formatMajor(amount);
  }

  function setActiveDescendant(index, items) {
    /* Keep aria-selected in sync for screen readers */
    items.forEach(function (el) { el.setAttribute('aria-selected', 'false'); });
    if (index >= 0 && index < items.length) {
      items[index].setAttribute('aria-selected', 'true');
    }
    input.setAttribute('aria-activedescendant', index >= 0 && index < items.length
      ? items[index].id : '');
  }

  /* ── Render predictive dropdown - comic card style ────────────── */
  function renderDropdown(products, articles, q) {
    dropdown.innerHTML = '';
    var all = [];

    products.forEach(function (p) {
      all.push({
        type : 'product',
        title: p.title,
        url  : p.url,
        /* Request 96px image so it looks crisp at 48×48 comic-card size */
        image: p.featured_image && p.featured_image.url
          ? p.featured_image.url.replace('{width}', '96')
          : '',
        price:     p.price ? money(p.price) : '',
        compareAt: p.compare_at_price_min && +p.compare_at_price_min > +p.price ? money(p.compare_at_price_min) : ''
      });
    });
    articles.forEach(function (a) {
      all.push({ type: 'article', title: a.title, url: a.url, image: '', price: '' });
    });

    if (all.length === 0) { dropdown.hidden = true; return; }

    all.forEach(function (item, i) {
      var a = document.createElement('a');
      a.className = 'ks__dropdown-item';
      a.href      = item.url;
      a.id        = 'ks-result-' + i;
      a.setAttribute('role', 'option');
      a.setAttribute('aria-selected', 'false');
      a.setAttribute('tabindex', '0');
      a.setAttribute('data-ks-result-index', i);

      if (item.image) {
        var img     = document.createElement('img');
        img.src     = item.image;
        img.alt     = item.title;
        img.className = 'ks__dropdown-img';
        img.width   = 48;
        img.height  = 48;
        img.loading = 'lazy';
        a.appendChild(img);
      }

      var info = document.createElement('div');
      info.className = 'ks__dropdown-info';

      var name = document.createElement('div');
      name.className   = 'ks__dropdown-name';
      name.textContent = item.title;
      info.appendChild(name);

      if (item.price) {
        var priceRow       = document.createElement('div');
        priceRow.className = 'ks__dropdown-prices';
        var price          = document.createElement('span');
        price.className    = 'ks__dropdown-price';
        price.textContent  = item.price;
        priceRow.appendChild(price);
        if (item.compareAt) {
          var compareAt         = document.createElement('span');
          compareAt.className   = 'ks__dropdown-compare';
          compareAt.textContent = item.compareAt;
          priceRow.appendChild(compareAt);
        }
        info.appendChild(priceRow);
      } else if (item.type === 'article') {
        var type       = document.createElement('div');
        type.className = 'ks__dropdown-type';
        type.textContent = 'Blog post';
        info.appendChild(type);
      }

      a.appendChild(info);
      dropdown.appendChild(a);
    });

    /* "See all" link - encodeURIComponent preserved */
    var viewAll       = document.createElement('a');
    viewAll.className = 'ks__dropdown-all';
    viewAll.href      = '/search?q=' + encodeURIComponent(q) + '&type=product,article';
    viewAll.textContent = 'See all results for "' + q + '"';
    dropdown.appendChild(viewAll);

    dropdown.hidden = false;
    activeIndex = -1;
    input.setAttribute('aria-activedescendant', '');
  }

  /* ── Fetch from /search/suggest.json - 300ms debounce ────────── */
  function fetchSuggestions(q) {
    fetch(
      '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product,article&resources[limit]=5&resources[limit_scope]=each'
    )
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var res = (data.resources && data.resources.results) || {};
        renderDropdown(res.products || [], res.articles || [], q);
      })
      .catch(function () { dropdown.hidden = true; });
  }

  /* ── Keyboard navigation ──────────────────────────────────────── */
  function moveFocus(dir) {
    var items = Array.prototype.slice.call(dropdown.querySelectorAll('[data-ks-result-index]'));
    if (!items.length) return;
    activeIndex = activeIndex + dir;
    if (activeIndex >= items.length) { activeIndex = -1; input.focus(); return; }
    if (activeIndex < 0) activeIndex = items.length - 1;
    setActiveDescendant(activeIndex, items);
    items[activeIndex].focus();
  }

  /* ── Events ───────────────────────────────────────────────────── */
  input.addEventListener('input', function () {
    clearTimeout(timer);
    var q = this.value.trim();
    if (q.length < 2) { dropdown.hidden = true; return; }
    timer = setTimeout(function () { fetchSuggestions(q); }, 300);
  });

  input.addEventListener('keydown', function (e) {
    if (e.key === 'Escape')    { dropdown.hidden = true; activeIndex = -1; return; }
    if (e.key === 'ArrowDown') { e.preventDefault(); moveFocus(1);  }
    if (e.key === 'ArrowUp')   { e.preventDefault(); moveFocus(-1); }
  });

  dropdown.addEventListener('keydown', function (e) {
    if (e.key === 'Escape')    { dropdown.hidden = true; input.focus(); return; }
    if (e.key === 'ArrowDown') { e.preventDefault(); moveFocus(1);  }
    if (e.key === 'ArrowUp')   { e.preventDefault(); moveFocus(-1); }
  });

  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      input.value = '';
      dropdown.hidden = true;
      input.focus();
    });
  }

  /* Close on outside click */
  document.addEventListener('click', function (e) {
    var wrap = document.querySelector('[data-ks-search-wrap]');
    if (wrap && !wrap.contains(e.target)) dropdown.hidden = true;
  });
})();
